import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useAddEditZoneStore = defineStore('addEditZone', () => {
  const manipulationMethod = ref('')
  const addZoneDialogVisible = ref(false)
  const editZoneDialogVisible = ref(false)

  // For J2EE web Zone, J2EE app Zone
  const addWebUrlDialogVisible = ref(false)
  const manipulateWebUrlMethod = ref('')
  const domainId4AddWebUrl = ref(0)
  const zoneType4WebUrl = ref(0)
  const webUrlItem = ref()

  return {
    manipulationMethod,
    addZoneDialogVisible,
    editZoneDialogVisible,
    addWebUrlDialogVisible,
    manipulateWebUrlMethod,
    domainId4AddWebUrl,
    zoneType4WebUrl,
    webUrlItem
  }
})
